/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { IncomingContent } from '@/data/types/IncomingContent';
import { Layout } from '@/data/types/Layout';
import { getContentItemForSlot } from '@/data/utils/getContentItemForSlot';

export const getProductPageCustom = (props: IncomingContent): Layout => ({
	name: 'AsideExtended',
	slots: {
		header: [{ name: 'Header', id: 'header' }],
		first: getContentItemForSlot(props, 'first'),
		second: getContentItemForSlot(props, 'second'),
		// second: [{ name: 'ProductDetails', id: props.tokenExternalValue }],
		third: getContentItemForSlot(props, 'third'),
		fourth: getContentItemForSlot(props, 'fourth'),
		fifth: [{ name: 'ProductDetails', id: props.tokenExternalValue }],
		footer: [{ name: 'Footer', id: 'footer' }],
		pdp: [{ name: 'pdp', id: 'pdp' }],
	},
});
